// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"c89e9a69","313":"956b2578","316":"1412d9e6","491":"91920910","796":"0971ca9c"}[chunkId] + ".chunk.js";
};